import axios from "../../config/interceptor";

export const postUseActiveDeposit = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/active-deposit`, data);

    return response;
  } catch (error) {
    return error;
  }
};

export const postUndoActiveDeposit = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/active-deposit/undo`, data);

    return response;
  } catch (error) {
    return error;
  }
};
